import { Controller } from "@hotwired/stimulus";
import { application } from "src/stimulus/application";

// landIeul: components/FAQ/index.tsx の scrollToSection を再現。
// カテゴリーカードのクリックで対象セクションへスムーススクロールする。
class SiteFaqFaqController extends Controller {
  scroll(event: Event): void {
    const el = event.currentTarget as HTMLElement;
    const id = el.dataset.section;
    if (!id) return;
    const target = document.getElementById(id);
    if (target) target.scrollIntoView({ behavior: "smooth", block: "start" });
  }
}

application.register("site--faq--faq", SiteFaqFaqController);
